import { Validator } from '@vista-digital/validator';
/**
 * Media type options for the Film Image component.
 */
export var FilmImageMediaType;
(function (FilmImageMediaType) {
    FilmImageMediaType["Advertisement"] = "Advertisement";
    FilmImageMediaType["Backdrop"] = "Backdrop";
    FilmImageMediaType["Poster"] = "Poster";
    FilmImageMediaType["Still"] = "Still";
    FilmImageMediaType["TitleTreatment"] = "TitleTreatment";
})(FilmImageMediaType || (FilmImageMediaType = {}));
export const filmImageMediaTypeValidator = Validator.oneOf(Object.values(FilmImageMediaType));
//# sourceMappingURL=media-type.js.map